var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.helpBlock)?_c('HTMLContent',{attrs:{"content":_vm.helpBlock.content}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }